import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from '../lib/tracker';

/**
 * Mount once inside <BrowserRouter>. Fires a 'pageview' event on every route change.
 * Also pushes a GTM `page_view` event to window.dataLayer so GTM-5FXLBKGC tracks
 * SPA navigations across ALL routes (public, customer, admin, super admin).
 * Skips internal admin/panel routes for the in-house tracker only (GTM still fires).
 */
export default function PageviewTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    // GTM SPA page_view — fires for every route (public + auth + dashboards)
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'page_view',
        page_title: document.title,
        page_location: window.location.href,
        page_path: window.location.pathname + window.location.search,
      });
    } catch (e) { /* noop */ }

    // In-house tracker — public pages only
    if (pathname.startsWith('/admin') || pathname.startsWith('/official')) return;
    trackPageview({});
  }, [pathname]);
  return null;
}
